import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { FileUploadModule } from "ng2-file-upload/ng2-file-upload";
import { AdministracionContactosComponent } from "./administracion-contactos.component";
import { AdministracionContatosService } from "./administracion-contactos.service";
import { AccordionModule } from "ngx-accordion";

@NgModule({
    declarations: [AdministracionContactosComponent],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        DataTableModule,
        FileUploadModule,
        AccordionModule],
    providers: [AdministracionContatosService],
    exports: [AdministracionContactosComponent]
})

export class AdministracionContactosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/administracion-contactos/administracion-contactos.module.ts